var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "add-to-favourites-btn js-add-to-favourites",
      class: { "is-active": _vm.isActive },
      on: { click: _vm.toggleFavourite }
    },
    [_vm._v(_vm._s(_vm.favouritesText)), _c("span", [_vm._v(" to Favourites")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib?{}!./scripts/vue/ButtonFavourites.vue?vue&type=template&id=78442f20&
// module id = 11
// module chunks = 0 1 2 3 4 5 6 8